import { Button } from "@components/atoms/buttons/button/button";
import deleteLicensedConfiguration from "@src/cloud-connect/use-cases/delete-licensed-configuration";
import { useI18N } from "@src/language/language-context";
import React, { useState } from "react";

export const DeleteConfigurationButton = ({ id }: { id: string }) => {
  const i18n = useI18N();
  const [loading, setLoading] = useState(false);

  const onDelete = async () => {
    setLoading(true);

    try {
      await deleteLicensedConfiguration(id);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      disabled={loading}
      variant="secondary"
      fun={onDelete}
      text={i18n("pages.configurationManager.delete")}
    />
  );
};
